import type { MyTenantsResult, TenantFeatures } from "breuer-supercharged-sdk";

export function tenantHasFeature(tenant: MyTenantsResult | null, feature: TenantFeatures): boolean {
  return tenant?.tenant?.features?.includes(feature) ?? false;
}

/** Fresh server entry for the selected tenant, or null when there is nothing to update. */
export function findRefreshedTenant(
  selected: MyTenantsResult | null,
  fresh: readonly MyTenantsResult[],
): MyTenantsResult | null {
  if (!selected) return null;
  const match = fresh.find((t) => t.tenantId === selected.tenantId);
  if (!match) return null;
  return JSON.stringify(match) === JSON.stringify(selected) ? null : match;
}
